export default __webpack_public_path__ + "static/fc4c4517-4cea-4adc-be90-7cfd3185c990-90a31d1619e9e4fcc3244269449f3f3b.woff2";